import { GetAtendimentoAssistenciaTecnicaService } from "../../../Services/AssistenciaTecnica/Atendimento/AtendimentoServices";
import { Controller } from "../../Controller";

export function GetAtendimentoAssistenciaTecnicaController(idCaso: number) {
    return Controller(GetAtendimentoAssistenciaTecnicaService(idCaso));
}
